module.exports = __webpack_public_path__ + "static/img/noResult.1d8d9c4e.svg";